import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'convfact-contactbankaccount',
    templateUrl: './contactbankaccount.component.html',
    styleUrls: ['./contactbankaccount.component.css'],
    standalone: false
})
export class ContactBankAccountComponent {
  contactUid: string;
  bankAccountUid: string | null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.contactUid = this.route.parent?.snapshot.paramMap.get('contactUid');
    const uid = this.route.snapshot.paramMap.get('bankAccountUid');
    this.bankAccountUid = uid && uid.length === 36 ? uid : null;
  }

  returnToIndex(): void {
    this.router.navigate(['/contact', this.contactUid, 'bank-accounts']);
  }
}
